import { request } from './api-client';
import type { AIModelPricing, AIUsageSummary, AICostLogError, AICostLogErrorsResponse } from './types';

export type { AIModelPricing, AIUsageSummary, AICostLogError, AICostLogErrorsResponse };

export async function getModelPricing(): Promise<{ data: AIModelPricing[] }> {
  return request(`/ai/pricing`);
}

export async function getModelPricingByProvider(providerId: string): Promise<{ data: AIModelPricing[] }> {
  return request(`/ai/pricing/providers/${providerId}/models`);
}

export async function createModelPricing(
  providerId: string,
  data: {
    model: string;
    inputPricePerMToken: number;
    outputPricePerMToken: number;
    cachedInputPricePerMToken?: number;
  }
): Promise<{ data: { id: string } }> {
  return request(`/ai/pricing/providers/${providerId}/models`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateModelPricing(
  id: string,
  data: {
    inputPricePerMToken: number;
    outputPricePerMToken: number;
    cachedInputPricePerMToken?: number;
  }
): Promise<{ data: { id: string; updatedAt: string } }> {
  return request(`/ai/pricing/models/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteModelPricing(id: string): Promise<{ data: { deleted: boolean } }> {
  return request(`/ai/pricing/models/${id}`, {
    method: 'DELETE',
  });
}

export async function getUsageSummary(
  startDate?: string,
  endDate?: string
): Promise<{ data: AIUsageSummary }> {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const qs = params.toString();
  return request(`/ai/usage/summary${qs ? '?' + qs : ''}`);
}

export async function getCostLogErrors(
  page = 1,
  pageSize = 50,
): Promise<AICostLogErrorsResponse> {
  return request<AICostLogErrorsResponse>(
    `/analytics/ai-cost-log-errors?page=${page}&pageSize=${pageSize}`,
  );
}
